<app-bigbluebutton [room]="room"></app-bigbluebutton>